import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomogenizationOrderAddPage } from './homogenization-order-add';
import { DatePickerModule } from 'ion-datepicker';
import { MomentModule } from 'angular2-moment/moment.module';

@NgModule({
    declarations: [
        HomogenizationOrderAddPage,
    ],
    imports: [
        IonicPageModule.forChild(HomogenizationOrderAddPage),
        DatePickerModule,
        MomentModule
    ],
})
export class HomogenizationOrderAddPageModule { }


// WEBPACK FOOTER //
// ./src/pages/homogenization-order-add/homogenization-order-add.module.ts